import React from 'react';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { InfoLine } from './InfoLine';
export const ORDER_REFERENCE_CUSTOM_FIELD_KEY = 'invoices.document.order-number';
export const OrderReference = withTranslation()(({ customFields, t }) => {
    const orderReferenceCustomField = customFields?.find(({ originCustomFieldKey }) => originCustomFieldKey === ORDER_REFERENCE_CUSTOM_FIELD_KEY);
    return orderReferenceCustomField ? (React.createElement(InfoLine, { dataHook: "order-reference" }, t('invoice-view:invoice-view.order-number.label', {
        orderNumber: orderReferenceCustomField.value.value,
    }))) : null;
});
//# sourceMappingURL=OrderReference.js.map